let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9CFJc")).then(() => parcelRequire('lk8G1'));